// Events adapter (cross-tab BroadcastChannel). Names the channels the assistant
// uses in one place and gives a single creation point, so the 5 instantiation
// sites stop repeating the channel-name strings. (A higher-level pub/sub wrapper
// and the LIFE_CYCLE_EVENT_BUS wrapper are follow-on increments of the events
// adapter.)
export const CHANNELS = {
  assistant: 'magic-apron-assistant',
  newMessage: 'magic-apron-new-message',
};

export const createBroadcastChannel = (name) => new BroadcastChannel(name);
